"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@/utilities/core/cn";
import { initialsFromName } from "@/utilities/formatting/playerInitials";
interface PlayerImageProps {
  photoUrl?: string;
  name: string;
  size?: "sm" | "md";
}

/**
 * PlayerImage — displays a player's photo if available; otherwise renders
 * their initials on a solid muted background. Used in the match events
 * timeline where goal scorers / card recipients / substitutions appear.
 */
export const PlayerImage: React.FC<PlayerImageProps> = t0 => {
  const $ = _c(15);
  const {
    photoUrl,
    name,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const sizeClasses = size === "sm" ? "w-8 h-8" : "w-12 h-12";
  if (photoUrl) {
    let t2;
    if ($[0] !== sizeClasses) {
      t2 = cn(sizeClasses, "rounded-full border-2 border-foreground/40 shadow-sm", "object-cover bg-muted/50");
      $[0] = sizeClasses;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== name || $[3] !== photoUrl || $[4] !== t2) {
      t3 = <img src={photoUrl} alt={name} className={t2} />;
      $[2] = name;
      $[3] = photoUrl;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t2;
  if ($[6] !== name) {
    t2 = initialsFromName(name);
    $[6] = name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const initials = t2;
  const textSizeClass = size === "sm" ? "text-xs" : "text-sm";
  let t3;
  if ($[8] !== sizeClasses || $[9] !== textSizeClass) {
    t3 = cn(sizeClasses, "rounded-full border-2 border-foreground/40 shadow-sm", textSizeClass, "flex items-center justify-center font-semibold uppercase bg-muted-foreground text-background select-none");
    $[8] = sizeClasses;
    $[9] = textSizeClass;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== initials || $[12] !== name || $[13] !== t3) {
    t4 = <div role="img" aria-label={name} className={t3}>{initials}</div>;
    $[11] = initials;
    $[12] = name;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};